import { useRef } from "react";

import { RESEND_VERIFICATION_EMAIL } from "@/graphql/accounts";
import ChevronComponent from "@/tpo/Chevron";
import { IndicativeButton } from "@/v2/Buttons";
import { useMutation } from "@apollo/client";

export default function ResendEmailVerificationLink({
  color = "dark",
  buttonText = "send platform invite",
  id,
  onSuccess,
  size = ["xs", "sm", "sm"],
  variableName = "organisationPatient"
}) {
  const ref = useRef();

  const [resendVerificationEmailMutation] = useMutation(RESEND_VERIFICATION_EMAIL, {
    onCompleted: () => {
      ref.current.setSuccessful(true);
      ref.current.setPending(false);
      if (onSuccess) {
        onSuccess();
      }
    },
    onError: () => {
      ref.current.setSuccessful(false);
      ref.current.setPending(false);
    },
    variables: {
      input: {
        [variableName]: id
      }
    }
  });

  return (
    <IndicativeButton
      ref={ref}
      defaultColor={color}
      pendingColor="darkgrey"
      successColor="#2ecc71"
      failureColor="error"
      rightIcon={<ChevronComponent />}
      type="button"
      onClick={resendVerificationEmailMutation}
      size={size}
    >
      {buttonText}
    </IndicativeButton>
  );
}
